import { render, staticRenderFns } from "./buyCode.vue?vue&type=template&id=a4201814&"
import script from "./buyCode.vue?vue&type=script&lang=js&"
export * from "./buyCode.vue?vue&type=script&lang=js&"
import style0 from "./buyCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports